import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrganization = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_15_7831",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_15_7831)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2.7085 17.1475V5.8975H6.04183V2.56416H13.9585V9.23083H17.2918V17.1475H11.0418V13.8142H8.9585V17.1475H2.7085ZM3.9585 15.8975H6.04183V13.8142H3.9585V15.8975ZM3.9585 12.5642H6.04183V10.4808H3.9585V12.5642ZM3.9585 9.23083H6.04183V7.1475H3.9585V9.23083ZM7.29183 12.5642H9.37516V10.4808H7.29183V12.5642ZM7.29183 9.23083H9.37516V7.1475H7.29183V9.23083ZM7.29183 5.8975H9.37516V3.81416H7.29183V5.8975ZM10.6252 12.5642H12.7085V10.4808H10.6252V12.5642ZM10.6252 9.23083H12.7085V7.1475H10.6252V9.23083ZM10.6252 5.8975H12.7085V3.81416H10.6252V5.8975ZM13.9585 15.8975H16.0418V13.8142H13.9585V15.8975ZM13.9585 12.5642H16.0418V10.4808H13.9585V12.5642Z",
			fill: "#152A58"
		})
	})]
});
export default SvgOrganization;
